import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { CountryTable, CountrySearchInput } from 'widgets/CountryTable';
import tabStyles from 'shared/styles/ant-custom-components/tabs.module.scss';

const CountriesPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article style={{ height: '100%' }}>
      <Tabs
        className={tabStyles.customTabs}
        tabBarExtraContent={{
          right: <CountrySearchInput />,
        }}
        items={[
          {
            label: t('Country:CountryTable.heading'),
            key: 'countries',
            children: <CountryTable />,
          },
        ]}
      />
    </article>
  );
};

export default CountriesPage;
